export default function FormatPhone(string) {
  if (string) {
    const Numbers = ['0','1','2','3','4','5','6','7','8','9'];
  
    let res = string.split('').filter(num => Numbers.includes(num)).join('')
    return '+' + res;
  } else {
    return undefined;
  }
}